import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Dashboard from './components/Dashboard'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Routes>
          <Route 
            path="/" 
            element={<Dashboard />} 
          />
          
          <Route 
            path="/dashboard" 
            element={<Dashboard />} 
          />
        </Routes>
      </div>
    </Router>
  )
}

export default App 